import { useQuery } from '@tanstack/react-query';

import getLibrarySections from '@/requests/library/getLibrarySections';

import type { LibrarySection } from '@/types';

// Shared with non-hook prefetchers (preset-feed deeplink) — the key and fn
// must stay single-sourced or a mismatch silently misses the cache.
export const librarySectionsQueryOptions = {
  queryKey: ['library-sections'],
  queryFn: getLibrarySections,
  // Cache for 5 minutes to prevent duplicate requests when remounting
  staleTime: 5 * 60 * 1000,
  // Keep in cache for 10 minutes
  gcTime: 10 * 60 * 1000,
} as const;

/**
 * Single batch fetch of all library sections. Tabs derive from the same
 * response (`section.title`/`section.slug`), so the whole library costs one
 * request. Sections arrive together and in hub order, which also preserves
 * the stable row indices the deeplink scroll relies on.
 */
const useLibrarySectionsQuery = () => {
  return useQuery<LibrarySection[] | null>(librarySectionsQueryOptions);
};

export default useLibrarySectionsQuery;
